<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field>
        <label>{{ $t("communication.template_type") }}</label>
        <md-select
          :disabled="!!currentTemplate._id"
          name="typeTemplate"
          v-model="currentTemplate.type"
        >
          <md-option
            v-for="(type, idx) in TYPE_TEMPLATE"
            :value="type.id"
            :key="'type' + idx"
            >{{ $t(type.name) }}</md-option
          >
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <validation-field :validations="templateValidation.name" name="name">
        <label>{{ $t("communication.template_name") }}</label>
        <md-input v-model="currentTemplate.name" required></md-input>
        <span
          style="top: 40px"
          class="md-error"
          v-if="serverValidations.name"
          >{{ serverValidations.name }}</span
        >
      </validation-field>
    </div>

    <div
      class="md-layout-item md-size-50 md-small-size-100"
      v-if="currentTemplate.type === 'email'"
    >
      <md-field>
        <label>{{ $t("communication.choose_attach_file") }}</label>
        <md-file
          @md-change="upLoadFile($event)"
          v-model="currentTemplate.attachments[0].name"
        ></md-file>
        <a
          :href="currentTemplate.attachments[0].src"
          v-if="currentTemplate.attachments[0].name"
          class="
            file-name
            font-medium
            text-base
            cursor-pointer
            text-gray-700
            duration-150
            break-words
          "
        >
          <md-icon class="mt-[-4px] duration-150">cloud_download</md-icon></a
        >
      </md-field>
    </div>

    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field>
        <label>{{ $t("communication.title") }}</label>
        <md-input v-model="currentTemplate.title"></md-input>
      </md-field>
    </div>

    <div
      class="md-layout-item md-size-100 md-small-size-100 variable-layout"
      v-if="currentTemplate.type === 'email'"
    >
      <div class="variable-system">
        <span
          class="variable-item"
          v-for="(variable_system, variable) in VARIABLE_SYSTEM"
          :key="variable"
        >
          <span>{{ variable_system.key }}</span> = {{ variable_system.value }}
        </span>
      </div>
      <div class="variable-config mt-5">
        <div class="md-layout">
          <div class="md-list-item md-size-33 md-small-size-100">
            <md-field
              v-for="(variable_config,
              variableIndex) in currentTemplate.variables"
              :key="variableIndex"
            >
              <label>{{ $t("communication.variable") }}</label>
              <md-input type="text" v-model="variable_config.key" />
              <span
                style="cursor: pointer"
                @click="deleteVariables(variableIndex)"
              >
                <md-icon style="color: red">delete_forever</md-icon>
              </span>
            </md-field>
          </div>
        </div>
      </div>
      <span @click="addVariationConfig()" class="btn-success md-button">
        + {{ $t("common.add") }}
      </span>
    </div>

    <div class="editor-block">
      <p class="text-right text-sm -mb-2">
        {{ this.currentTemplate.content.length }}
        {{ $t("communication.characters") }}
      </p>
      <validation-field
        :validations="templateValidation.content"
        name="content"
      >
        <Editor
          v-model="currentTemplate.content"
          v-if="currentTemplate.type === 'email'"
          :placeholder="$t('communication.please_enter_content')"
          required
          :api-key="EDITOR_API_KEY"
          :init="{
            height: 200,
            menubar: true,
            plugins: EDITOR_PLUGINS,
            toolbar: EDITOR_TOOLBAR
          }"
        />
        <textarea
          v-else
          v-model="currentTemplate.content"
          class="relative bg-[#ffffff00] z-10"
        ></textarea>
        <span
          v-if="!currentTemplate.content"
          class="place-holder"
          data-text=" *"
          >{{ $t("communication.please_enter_content") }}</span
        >
        <span class="md-error" v-if="serverValidations.content">{{
          serverValidations.content
        }}</span>
      </validation-field>
    </div>
  </div>
</template>
<script>
import { postFileToS3 } from "@/helpers/aws-s3";
import AWSConst from "@/constants/AWS";
import { EDITOR_PLUGINS, EDITOR_TOOLBAR, EDITOR_API_KEY } from "./utils";
import Editor from "@tinymce/tinymce-vue";
import { VARIABLE_SYSTEM, TYPE_TEMPLATE } from "@/constants";

export default {
  name: "TemplateForm",
  components: { Editor },
  props: ["currentTemplate", "serverValidations", "templateValidation"],
  data() {
    return {
      EDITOR_PLUGINS,
      EDITOR_API_KEY,
      EDITOR_TOOLBAR,
      VARIABLE_SYSTEM,
      TYPE_TEMPLATE
    };
  },
  methods: {
    async upLoadFile(e) {
      // this.currentTemplate.attachments[0].src = await this.uploadFileToS3(e[0]);
      this.currentTemplate.attachments[0].src = await this.uploadFileToS3(
        this.changeFileName(e[0])
      );
    },
    changeFileName(file) {
      return new File([file], file.name.replace("-", "_"), { type: file.type });
    },
    uploadFileToS3(file) {
      return postFileToS3(
        `${AWSConst.S3_COMMUNICATION_UPLOAD_PATH}/template`,
        file
      );
    },
    addVariationConfig() {
      this.currentTemplate.variables.push({ key: "", value: "" });
    },
    deleteVariables(index) {
      this.currentTemplate.variables.splice(index, 1);
    }
  },
  watch: {
    "currentTemplate.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    }
  }
};
</script>
<style lang="scss">
.tox-tinymce-aux {
  position: fixed !important;
}
.editor-block {
  width: 100%;
  padding: 20px;
  box-sizing: content-box;
  .md-field {
    display: block !important;
  }
  textarea {
    width: 100%;
    border: 1px solid #c7c7c7;
    border-radius: 2px;
    font-size: 14px;
    min-height: 120px;
    padding: 10px;
  }
  .tox-tinymce {
    width: 100%;
  }
}
.variable-system {
  .variable-item {
    background-color: #d0d0d0;
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 1px;
    display: inline;
    padding: 3px 10px;
  }
}
.variable-config {
  .variable-item {
    display: inline-block;
    margin-right: 10px;
    margin-top: 10px;
    input {
      border-bottom: 1px solid;
    }
  }
}
.btn-success {
  line-height: 30px;
  text-align: center;
  font-weight: 600;
  color: green !important;
  background-color: transparent !important;
  padding: 5px 15px;
}
.place-holder {
  position: absolute;
  left: 0;
  top: 0;
  padding: 12px 0 0 12px;
  font-size: 14px;
}
span:after {
  color: red;
  content: attr(data-text);
}
</style>
